import {
    createContext,
    useState,
    ReactNode,
    useCallback,
    FC,
    useContext,
    Dispatch,
    SetStateAction,
} from 'react';
import { useDispatch } from 'react-redux';
import { updateRelayVariables } from '../../actions/sharedRelayVariableActions';

type Props = {
    children: ReactNode;
};

type StateSetter<T> = Dispatch<SetStateAction<T>>;

type AuctionContext = {
    isBiddingDisabled: boolean;
    setIsBiddingDisabled: StateSetter<boolean>;
    shouldDisplayCountdown: boolean;
    setShouldDisplayCountdown: StateSetter<boolean>;
    dispatchUpdateAuctionItem: () => void;
};

export const PdpSharedAuctionContext = createContext<AuctionContext>({
    isBiddingDisabled: false,
    setIsBiddingDisabled: () => {},
    shouldDisplayCountdown: false,
    setShouldDisplayCountdown: () => {},
    dispatchUpdateAuctionItem: () => {},
});

export const useSharedAuctionContext = (): AuctionContext => useContext(PdpSharedAuctionContext);

export const PdpSharedAuctionContextProvider: FC<Props> = ({ children }) => {
    const [isBiddingDisabled, setIsBiddingDisabled] = useState(false);
    const [shouldDisplayCountdown, setShouldDisplayCountdown] = useState(false);
    const dispatch = useDispatch();

    // this refreshes the page to enter ACTIVE or PREVIEW state
    const dispatchUpdateAuctionItem = useCallback(() => {
        dispatch(updateRelayVariables({ updateAuctionItem: true }));
    }, [dispatch]);

    return (
        <PdpSharedAuctionContext.Provider
            value={{
                isBiddingDisabled,
                setIsBiddingDisabled,
                dispatchUpdateAuctionItem,
                shouldDisplayCountdown,
                setShouldDisplayCountdown,
            }}
        >
            {children}
        </PdpSharedAuctionContext.Provider>
    );
};
